import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "apps-module/app/common-components/common-components.module";
import { NouisliderModule } from "ng2-nouislider";

import { CapacityFilterComponent } from "./components/capacity-filter/capacity-filter.component";
import { CheckboxComponent } from "./components/facilities-filter/checkbox/checkbox.component";
import { FacilitiesFilterComponent } from "./components/facilities-filter/facilities-filter.component";
import { ResultItemComponent } from "./components/search-results/result-item/result-item.component";
import { SearchResultsComponent } from "./components/search-results/search-results.component";
import { VenuesSearchComponent } from "./venues-search.component";

@NgModule({
    declarations: [
        VenuesSearchComponent,
        CapacityFilterComponent,
        FacilitiesFilterComponent,
        CheckboxComponent,
        ResultItemComponent,
        SearchResultsComponent
    ],
    exports: [VenuesSearchComponent],
    imports: [
        CommonComponentsModule,
        NouisliderModule
    ]
})
export class VenuesSearchModule {
}
